import React from "../_snowpack/pkg/react.js";
import {Outlet} from "../_snowpack/pkg/react-router-dom.js";
import "./App.css";
import "../_snowpack/pkg/bootstrap/dist/css/bootstrap.min.css";
import NavBar from "./Components/NavBar/NavBar.js";
const App = () => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "App"
  }, /* @__PURE__ */ React.createElement(NavBar, null), /* @__PURE__ */ React.createElement(Outlet, null));
};
export default App;
